import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_472: DocMigration = {
  maxSchemaVersion: "0.0.472",
  description: "Delete backup settings sets",
  apply(json: any) {
    delete json.backupPropSettingsSets;
    return json;
  },
};
export default migration_0_0_472;
